<template>
  <section id="pricing" class="pricing">
    <div class="container">
      <h2>加恒科技服务与定价</h2>
      <div class="plans">
        <div class="plan">
          <h3>开发者版</h3>
          <p class="price">¥0</p>
          <ul>
            <li>核心 SDK 与文档</li>
            <li>沙箱与测试工具</li>
          </ul>
          <a href="#" class="btn">立即开始</a>
        </div>
        <div class="plan featured">
          <h3>商业版</h3>
          <p class="price">¥299/月</p>
          <ul>
            <li>多平台分发与更新</li>
            <li>数据看板与 A/B 测试</li>
            <li>工作日技术支持</li>
          </ul>
          <a href="#" class="btn primary">预约演示</a>
        </div>
        <div class="plan">
          <h3>企业版</h3>
          <p class="price">面议</p>
          <ul>
            <li>企业级定制开发与集成</li>
            <li>数据平台、合规咨询与专属支持</li>
            <li>99.9% SLA · 加恒科技直签</li>
          </ul>
          <a href="mailto:bd@jiahengkeji.com" class="btn">联系销售</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Pricing'
}
</script>

<style scoped>
.pricing {
  padding: 64px 16px;
  background: #0b1020;
  color: #e5e7eb;
}
.container {
  max-width: 1100px;
  margin: 0 auto;
}
h2 {
  text-align: center;
  margin: 0 0 24px;
}
.plans {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.plan {
  background: #111827;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 18px;
  text-align: center;
}
.plan .price {
  font-size: 28px;
  margin: 6px 0 12px;
}
.btn {
  display: inline-block;
  padding: 10px 16px;
  border-radius: 8px;
  color: #e5e7eb;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
}
.primary {
  background: #22c55e;
  border-color: #22c55e;
  color: #0b1020;
}
.featured {
  transform: translateY(-6px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}
@media (max-width: 900px) {
  .plans {
    grid-template-columns: 1fr;
  }
  .featured {
    transform: none;
  }
}
</style>


